'use client'

import { useEffect } from 'react'
import { AdvancedButton } from '@/app/components/atoms/AdvancedButton'
import Heading from '@/app/components/atoms/Heading'
import Paragraph from '@/app/components/atoms/Paragraph'
import Section from '@/app/components/sections/Section'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <Section variant="lys" paddingTop="default" paddingBottom="default">
      <div className="col-span-full text-center space-y-6 my-24">
        <Heading type="h2" tag="h1">
          Hov, noget gik galt
        </Heading>
        <Paragraph>
          Vi kunne ikke indlæse siden lige nu. Prøv venligst igen om et øjeblik.
        </Paragraph>
        {error?.digest && (
          <Paragraph size="regular">
            <span className="opacity-60">Fejl-ID: {error.digest}</span>
          </Paragraph>
        )}
        <div className="flex justify-center">
          <AdvancedButton onClick={() => reset()} variant="primary">
            Prøv igen
          </AdvancedButton>
        </div>
      </div>
    </Section>
  )
}
